import { CheckCircle2, XCircle } from 'lucide-react'
import type { ReactNode } from 'react'
import { StatusDot } from '@/components/ui/badge'

export function HealthTile({
  icon,
  label,
  value,
  ok,
}: {
  icon: ReactNode
  label: string
  value: string
  ok: boolean
}) {
  return (
    <div className="flex items-center gap-3 rounded-md border p-3">
      <div className="shrink-0 text-muted-foreground">{icon}</div>
      <div className="flex-1 max-md:min-w-0">
        <div className="text-xs text-muted-foreground">{label}</div>
        <div className="flex items-center gap-2 text-sm font-medium">
          <StatusDot status={ok ? 'active' : 'error'} />
          <span className="truncate">{value}</span>
        </div>
      </div>
      {ok ? (
        <CheckCircle2 className="h-4 w-4 shrink-0 text-success" />
      ) : (
        <XCircle className="h-4 w-4 shrink-0 text-destructive" />
      )}
    </div>
  )
}
